/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import {
  Modal,
  Typography,
  Divider,
  Table,
  Spin,
  Button,
  Popconfirm,
} from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MSG_TYPE } from "../../constants/messages";
import { BOOKING_SERVICE, DELETE_EXTRA_SERVICE } from "../../constants/api";

const { Text } = Typography;

const BookingAppliedServiceModal = ({ visible, onClose, booking_id }) => {
  const [bookingServices, setBookingService] = useState([]);
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    if (visible) {
      getBookingService();
    }
  }, [visible]);

  const getBookingService = () => {
    setLoading(true);
    const body = { id: booking_id };

    const successFn = (data) => {
      setLoading(false);
      if (data.status === true && data.data) {
        setBookingService(data.data);
      } else {
        onClose();
        displayMessage(ERROR_MSG_TYPE, data.message || "No services found");
      }
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to get services");
    };

    postAPI(BOOKING_SERVICE, body, successFn, errorFn);
  };

  const handleDelete = (id) => {
    const body = {
      booking_id,
      id,
    };

    const successFn = (data) => {
      if (data.status === true) {
        displayMessage(
          SUCCESS_MSG_TYPE,
          data.message || "Service deleted successfully"
        );
        getBookingService();
      } else {
        displayMessage(ERROR_MSG_TYPE, data.message || "Delete failed");
      }
    };

    const errorFn = () => {
      displayMessage(ERROR_MSG_TYPE, "Delete request failed");
    };

    postAPI(DELETE_EXTRA_SERVICE, body, successFn, errorFn);
  };

  const columns = [
    {
      title: "Service Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (value) => `₹${value}`,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "GST %",
      dataIndex: "gst_percent",
      key: "gst_percent",
      render: (value) => `${value}%`,
    },
    {
      title: "GST Amount",
      dataIndex: "gst_amount",
      key: "gst_amount",
      render: (value) => `₹${parseFloat(value).toFixed(2)}`,
    },
    {
      title: "Total",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (value) => `₹${parseFloat(value).toFixed(2)}`,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title={"Are you sure to delete this service?"}
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button danger size="small">
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  const getSummary = (data) => {
    let subtotal = 0;
    let gstTotal = 0;
    let grandTotal = 0;

    data.forEach((item) => {
      const price = Number(item.price || 0);
      const qty = Number(item.quantity || 1);
      const gstAmt = Number(item.gst_amount || 0);

      subtotal += price * qty;
      gstTotal += gstAmt;
      grandTotal += price * qty + gstAmt;
    });

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={2}>
          <Text strong>Subtotal:</Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell>₹{subtotal.toFixed(2)}</Table.Summary.Cell>
        <Table.Summary.Cell colSpan={2}>
          <Text strong>GST Total:</Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell>₹{gstTotal.toFixed(2)}</Table.Summary.Cell>
        <Table.Summary.Cell>
          <Text strong>Total: ₹{grandTotal.toFixed(2)}</Text>
        </Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  return (
    <Modal
      title="Booking Extra Services"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      zIndex={1000000}
    >
      <Divider />
      {loading ? (
        <div style={{ textAlign: "center", padding: "2rem 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Table
          dataSource={bookingServices}
          columns={columns}
          rowKey={(record) => record.extra_service_id}
          pagination={false}
          summary={() => getSummary(bookingServices)}
        />
      )}
      <Divider />
    </Modal>
  );
};

export default BookingAppliedServiceModal;
